//#region : Imports

import { Component, ViewChild } from "@angular/core";

import { GlobalsService } from "./globals.service";

import { Router } from "@angular/router";

import * as url from "url";

// import Typewriter from 'typewriter-effect/dist/core';

import Typewriter from "t-writer.js";

declare var $: any;

//#endregion

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  constructor(private globals: GlobalsService, private router: Router) {}

  private myStyle: object = {};
  private myParams: object = {};
  private width: number = 100;
  private height: number = 100;
  private showTypewriter: boolean = true;

  ngOnInit() {
    // public readonly showLoginanimation = false;
    this.showTypewriter = this.globals.buildSettings.showLoginanimation;
    this.showTypewriter = false;
    //Set the page title
    document.title = this.globals.buildSettings.tabName;
    let adr: string = document.URL;
    //Initialize bootstrap material
    //$('body').bootstrapMaterialDesign();

    //Set the font
    $("body").css("font-family", this.globals.buildSettings.fontFamily);

    if (window.location.pathname.indexOf("resetpass") != -1) {
      //Get token from href
      let href = window.location.href.split("=");
      this.globals.token = href[1];

      this.router.navigate(["resetpass"]);
    } else if (window.location.href.indexOf("token") != -1) {
      let adr: string = document.URL;
      let u = url.parse(adr, true);

      let itoken = Array.isArray(u.query.itoken)
        ? u.query.itoken[0]
        : u.query.itoken;
      let token = Array.isArray(u.query.token)
        ? u.query.token[0]
        : u.query.token;

      this.globals.token = token;
      this.globals.iotToken = itoken;

      // console.log(token)

      // //Redirect to logged in
      // this.globals.currentView = "dashboard";
      // this.router.navigate([this.globals.currentPage]);

      this.doBackgroundLogin(token);
    } else {
      this.router.navigate(["/"]);
    }

    window.addEventListener("beforeunload", (event) => {
      // if (!this.globals.signingOut)
      // {
      //     event.preventDefault();
      //     window.stop();
      //     //Chrome requires returnValue to be set
      //     event.returnValue = false;
      // }
    });

    //Particles animation
    this.myStyle = {
      // 'position': 'fixed',
      width: "100%",
      height: "100%",
      "z-index": 1000,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    };
    //Particles parmaters
    this.myParams = {
      particles: {
        number: {
          value: 150,
        },
        color: {
          value: "#ff0000",
        },
        shape: {
          type: "polygon",
        },
      },
    };
  }

  ngAfterViewInit() {
    //Typewriter

    if (this.showTypewriter) {
      const target1 = document.querySelector(".tw1");
      const target2 = document.querySelector(".tw2");
      const target3 = document.querySelector(".tw3");
      const target4 = document.querySelector(".tw4");

      const options = {
        loop: false,
        typeColor: "white",
        cursorColor: "white",
        animateCursor: false,
        typeSpeed: 120,
        deleteSpeed: 80,
      };

      const writer1 = new Typewriter(target1, options);
      const writer2 = new Typewriter(target2, options);
      const writer3 = new Typewriter(target3, options);
      const writer4 = new Typewriter(target4, options);
      // writer1
      //     .type("DISRUPTIVE. DIGITAL. INTELLIGENCE.")
      //     .rest(2000)
      //     .clear()

      //     .removeCursor()
      //     .rest(1000)
      //     .then(writer4.start.bind(writer4))
      //     .start()
      //     writer4
      //     .type("DISRUPTIVE.")
      //     .removeCursor()
      //     .then(writer2.start.bind(writer2))
      // writer2
      //     .type("DIGITAL.")
      //     .removeCursor()
      //     .then(writer3.start.bind(writer3))

      // writer3
      //     .type("INTELLIGENCE.")

      //     .removeCursor()

      // writer1
      //     .strings(1,
      //         "DISRUPTIVE",
      //         "DIGITAL",
      //         "INTELLIGENCE").start()

      writer4
        .strings(1, "INTELLIGENCE", "DIGITAL", "DISRUPTIVE ")
        .rest(4000)
        .remove(11)
        .removeCursor()
        .start();

      writer2
        .strings(1, "DISRUPTIVE", "INTELLIGENCE", "DIGITAL ")
        .rest(4000)
        .remove(8)
        .removeCursor()
        .start();

      writer3
        .strings(1, "DISRUPTIVE", "DIGITAL", "INTELLIGENCE ")
        .rest(4000)
        .remove(13)
        .removeCursor()
        .start();

      //Defer
      setTimeout(() => {
        this.showTypewriter = false;
      }, 12000);
    }
  }

  doBackgroundLogin(token) {
    //Login request
    let username = "dutoitdw@gmail.com";
    let pass = "000011112222333344445555666677778888";
    let otp = "1111";
    this.globals.login(
      username,
      pass,
      token,
      otp,
      "no-ask",
      () => {
        //Login to the IoT also
        this.globals.containerLogin(() => {
          this.globals.accountInfo(() => {
            //Success
            this.globals.currentView = "dashboard";
            this.router.navigate([this.globals.currentPage]);
            // this.busy = false;
          });
        });
      },
      (res?: any) => {
        if (res && (res.message == "User not active" || res.error == 108)) {
          this.globals.showWarningAlert("Error", "Account suspended.");
        } else {
          //Failure
          // if (this.loginState == "2FA")
          // {
          //     this.globals.showWarningAlert("Login Failed", "Incorrect code entered.");
          // }
          // else
          // {
          //     this.globals.showWarningAlert("Login Failed", "Username or Password is incorrect.");
          // }
        }

        // this.busy = false;
      },
      (result: any) => {
        //Two factor authentication
        let tfa: "scan" | "otp" = result.tfa;

        if (tfa == "scan") {
          //The server ask that I enter the OTP
          // this.loginState = "2FA-register";
          // this.qrCode = result.qrData;
        } else if (tfa == "otp") {
          //The server ask that I enter the OTP
          // this.loginState = "2FA";
        } else {
          //Should not get here
          // this.loginState = "login";
        }

        // this.busy = false;
      }
    );
  }
}
